<template>
    <div id="app" ref="app">
        <div>
            <img :src="BasePath + bodyImg" width="100%" class="head-img"/>
            <div class="head-bigDiv">
                <el-row>
                    <el-col :span="10">
                        <img class="head-bigDiv-logo" src="static/logo.jpg" width="100%"
                             style="margin-left:-15px;margin-top: 20px;"/>
                    </el-col>
                    <el-col :span="14">
                        <div style="margin-top: 60px;">
                            <div :style="{float:'left',width:(100 / (menulist.length + 1)) + '%'}"
                                 @click="MenulistClick('index')"
                                 @mouseover="HeadBigDivHover('-1')"
                                 @mouseleave="OffHeadBigDivHover('-1')"
                            >
                                <span class="el-dropdown-link">
                                    <div class="cursor" style="font-size: 18px;color: #1C6894"
                                    >
                                        <div class="head-bigDiv-hoverSpan" id="head-bigDiv-hoverSpan-1">
                                            网站首页
                                        </div>
                                     <div class="head-bigDiv-hoverDiv" id="head-bigDiv-hoverDiv-1"></div>
                                    </div>
                                </span>
                            </div>
                            <div :style="{float:'left',width:(100 / (menulist.length + 1)) + '%'}"
                                 v-for="(item,index) in menulist" :key="'menulist' + index"
                                 @click="MenulistClick(item.children[0])"
                                 @mouseover="HeadBigDivHover(item.id)"
                            >
                                <el-dropdown :hide-on-click="false" placement="bottom" @visible-change="visibleChange">
                                    <span class="el-dropdown-link">
                                        <div class=" cursor" style="font-size: 18px;color: #1C6894"
                                        >
                                            <div class="head-bigDiv-hoverSpan" :id="'head-bigDiv-hoverSpan' + item.id">
                                                {{item.catalogName}}
                                            </div>
                                         <div class="head-bigDiv-hoverDiv" :id="'head-bigDiv-hoverDiv' + item.id"></div>
                                        </div>
                                    </span>
                                    <el-dropdown-menu slot="dropdown" style="width: 450px;">
                                        <el-row>
                                            <el-col :span="colSpan[index]"
                                                    v-for="(ite,indexe) in item.children"
                                                    :key="'col' + indexe">
                                                <div class="head-bigDiv-dropdown-menu cursor"
                                                     @click="MenulistClick(ite)">
                                                    <i class="el-icon-arrow-left"/>
                                                    <span class="head-bigDiv-dropdown-menu-span">
                                                            {{ite.catalogName}}
                                                        </span>
                                                </div>
                                            </el-col>
                                        </el-row>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <el-carousel :interval="3000" height="500px">
                    <el-carousel-item v-for="(item,index) in imgs" :key="index" style="width: 100%">
                        <img style="float: left;z-index: 4"
                             :src="BasePath + item.carousel_PlayAddress + item.carousel_Filename" width="100%"
                             height="500px"/>
                        <h1 style="float: left;z-index: 5;margin-top: -400px;margin-left: 100px;color: #F2C743;font-size: 35px;letter-spacing:10px">
                            {{item.title}}
                        </h1>
                        <h1 style="float: left;z-index: 5;margin-top: -330px;margin-left: 170px;color:#F2C743;font-size: 35px;letter-spacing:10px">
                            {{item.context}}
                        </h1>
                    </el-carousel-item>
                </el-carousel>
                <el-row style="margin-top: 10px;background: rgb(239,239,239);line-height: 40px">
                    <el-col :span="3">
                        <img src="static/horn.png" width="18px" style="float: left;margin-top:12px"/>
                        <span style="margin-left: 5px;color: rgb(64,158,255);font-size: 17px">公告及通函:</span>
                    </el-col>
                    <el-col :span="21">
                        <el-carousel :interval="3000" height="40px" direction="vertical" indicator-position="none">
                            <el-carousel-item v-for="(item,index) in carouselText" :key="'carouselText'+index"
                                              style="width: 100%">
                                {{item.noticecontext}}
                            </el-carousel-item>
                        </el-carousel>
                    </el-col>
                </el-row>
            </div>
        </div>
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: 'App',
        data() {
            return {
                bodyImg: "",
                imgs: [],
                carouselText: [],
                menulist: [],
                HeadBigDivHoverId: "",
                colSpan: []
            }
        },
        created() {
            this.Init()
        },
        methods: {
            async Init() {
                let loadding = this.openLoading();
                // body图数据
                await this.$http.get('NormalManagel/GetAllBgImage').then(res => {
                    if (res.data.data && res.data.data.length) {
                        this.bodyImg = res.data.data[0].carousel_PlayAddress + res.data.data[0].carousel_Filename;
                    }
                }).catch(() => {
                    this.$message.error('服务器异常,请联系管理员!')
                })
                // 导航栏数据
                await this.$http.get('Admin/AdminIndex').then(res => {
                    this.menulist = res.data["role_dic"];
                    this.colSpan = [];
                    try {
                        for (let i = 0; i < res.data["role_dic"].length; i++) {
                            this.colSpan.push(8);
                            for (let l = 0; l < res.data["role_dic"][i].children.length; l++) {
                                if (res.data["role_dic"][i].children[l].catalogName.length > 15) {
                                    this.colSpan[i] = 24;
                                    break;
                                } else if (res.data["role_dic"][i].children[l].catalogName.length > 5) {
                                    this.colSpan[i] = 12;
                                    break;
                                }
                            }
                        }
                    } catch (e) {
                        console.log(e)
                    }
                }).catch(() => {
                    this.$message.error('服务器异常,请联系管理员!')
                })
                // 轮播图数据
                await this.$http.post('NormalManagel/GetCarouselContent', {
                    currentPage: 1,
                    pagesize: 10000,
                }).then(res => {
                    this.imgs = res.data.data;
                }).catch(() => {
                    this.$message.error('服务器异常,请联系管理员!')
                })
                // 公告数据
                await this.$http.post('Notice/GetAllNotice', {
                    currentPage: 1,
                    pagesize: 10000,
                }).then(res => {
                    this.carouselText = res.data.data;
                }).catch(() => {
                    this.$message.error('服务器异常,请联系管理员!')
                })
                loadding.close();
                // this.$http.get("/Home/IndexData").then(res => {
                //     console.log(res)
                // }).catch(() => {
                //
                // })
            },
            // 点击目录
            MenulistClick(item) {
                // 网站首页
                if (item === "index") {
                    this.$router.push({path: "/"})
                } else if (item) {
                    this.$router.push({path: "/Introduce", query: {catalogId: item.id, id: null}})
                    document.getElementsByTagName("html")[0].scrollTop = 700;
                }
                location.reload();
            },
            // 鼠标移动到目录
            HeadBigDivHover(id) {
                document.getElementById("head-bigDiv-hoverDiv-1").style.display = "none";
                document.getElementById("head-bigDiv-hoverSpan-1").style.marginTop = "0px"
                for (let i = 0; i < this.menulist.length; i++) {
                    document.getElementById("head-bigDiv-hoverDiv" + this.menulist[i].id).style.display = "none";
                    document.getElementById("head-bigDiv-hoverSpan" + this.menulist[i].id).style.marginTop = "0px"
                }
                document.getElementById("head-bigDiv-hoverDiv" + id).style.display = "inline-block";
                document.getElementById("head-bigDiv-hoverSpan" + id).style.marginTop = "-20px";
                this.HeadBigDivHoverId = id;
            },
            // 鼠标移出目录
            OffHeadBigDivHover(id) {
                document.getElementById("head-bigDiv-hoverDiv" + id).style.display = "none";
                document.getElementById("head-bigDiv-hoverSpan" + id).style.marginTop = "0px"
            },
            // 监听目录下拉框是否显示
            visibleChange(e) {
                if (!e) {
                    this.OffHeadBigDivHover(this.HeadBigDivHoverId);
                }
            },
        }
    }
</script>

<style>
    body, html {
        margin: 0;
        padding: 0;
        margin-left: auto;
        margin-right: auto;
        overflow: auto;
    }

    #app {
        min-width: 1400px !important;
        max-width: 2000px !important;
        margin-right: auto;
        margin-left: auto;
        height: 100%;
        width: 100%;
    }

    .head-img {
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1;
        float: left;
        max-width: 2000px;
        height: 800px;
    }

    .head-bigDiv {
        width: 80%;
        margin-left: 9%;
        height: 690px;
        background-color: white !important;
        z-index: 2;
        padding: 20px;
        margin-top: -700px;
        float: left;
    }

    .head-bigDiv-logo {
        margin: 20px;
    }

    .head-bigDiv-hoverDiv {
        width: 80px;
        height: 2px;
        background: #1C6894;
        display: none;
    }

    .head-bigDiv-hover:hover .head-bigDiv-hoverDiv {
        display: inline-block !important;
    }

    .head-bigDiv-hover:hover .head-bigDiv-hoverSpan {
        margin-top: -20px !important;
    }

    .head-bigDiv-dropdown-menu {
        border-bottom: 1px solid;
        border-color: antiquewhite !important;
        width: 80%;
        margin-top: 10px;
        padding-bottom: 10px;
        margin-left: 10%;
    }

    .cursor {
        cursor: pointer;
    }

    .head-bigDiv-dropdown-menu-span {
        margin-left: 5px;
    }

    .Index-head-bigDiv {
        width: 80%;
        margin-left: 9%;
        background-color: white !important;
        z-index: 2;
        padding: 20px;
        float: left;
    }

    .cursor {
        cursor: pointer;
    }

    .bottom a {
        text-decoration: none;
        color: black;
    }

    .bottom {
        width: 25%;
        float: left;
    }

    .bottom:hover .bottom-span {
        color: #1961AC;
        font-size: 17px;
    }

    .bottom:hover .bottom a {
        color: #1961AC;
        font-size: 17px;
    }

    .certificateLi {
        text-overflow: ellipsis; /*让截断的文字显示为点点。还有一个值是clip意截断不显示点点*/
        white-space: nowrap; /*让文字不换行*/
        overflow: hidden;
        margin-top: 5px;
    }

    table {
        border-top: 1px solid #ccc;
        border-left: 1px solid #ccc;
    }

    table td,
    table th {
        border-bottom: 1px solid #ccc;
        border-right: 1px solid #ccc;
        padding: 3px 5px;
    }

    table th {
        border-bottom: 2px solid #ccc;
        text-align: center;
    }

    /* blockquote 样式 */
    blockquote {
        display: block;
        border-left: 8px solid #d0e5f2;
        padding: 5px 10px;
        margin: 10px 0;
        line-height: 1.4;
        font-size: 100%;
        background-color: #f1f1f1;
    }

    /* code 样式 */
    code {
        display: inline-block;
        *display: inline;
        *zoom: 1;
        background-color: #f1f1f1;
        border-radius: 3px;
        padding: 3px 5px;
        margin: 0 3px;
    }

    pre code {
        display: block;
    }

    /* ul ol 样式 */
    ul, ol {
        margin: 10px 0 10px 20px;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue